import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";

import { DataGrid } from "@mui/x-data-grid";
import { FC, memo, useMemo, useState } from "react";
import { useProductsColumns } from "./hooks/useProductsColumns";
import { Skeleton } from "../../../components/loading";

interface ProductsTableProps {
  isLoading: boolean;
  products: { id: number; name: string }[] | undefined;
  text: string;
  id?: string;
}

export const ProductsTable: FC<ProductsTableProps> = memo(
  ({ isLoading, products, text, id }) => {
    const columns = useProductsColumns();
    const [searchCriteria, setSearchCriteria] = useState("");

    const filteredRows = useMemo(() => {
      return (
        products
          ?.filter(({ name }) => {
            return name
              .trim()
              .toLowerCase()
              .includes(searchCriteria.trim().toLowerCase());
          })
          .map(({ id, name }) => {
            return {
              id,
              productName: name,
            };
          }) || []
      );
    }, [products, searchCriteria]);

    return (
      <Stack gap={3} id={id}>
        <Box display="flex" justifyContent="space-between">
          <Typography variant="h2">
            <strong>{text}</strong>
          </Typography>
          <Box width={200}>
            <TextField
              type="search"
              fullWidth
              size="small"
              placeholder="Search for products..."
              value={searchCriteria}
              onChange={(event) => {
                setSearchCriteria(event.target.value);
              }}
            />
          </Box>
        </Box>

        <Skeleton isLoading={isLoading} height={400}>
          <DataGrid
            rows={filteredRows}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10,
                },
              },
              sorting: {
                sortModel: [
                  {
                    field: "productName",
                    sort: "asc",
                  },
                ],
              },
            }}
            sortingOrder={["asc", "desc"]}
            pageSizeOptions={[10]}
            disableColumnMenu
            disableColumnResize
            disableRowSelectionOnClick
            hideFooterSelectedRowCount
            sx={{
              border: "none",
              "& .MuiDataGrid-iconSeparator": {
                display: "none",
              },
            }}
          />
        </Skeleton>
      </Stack>
    );
  }
);

ProductsTable.displayName = "ProductsTable";
